export const select2State = {
    placeholder: "",
    allowClear: false,
    minimumResultsForSearch: -1,
    dropdownCssClass: 'state-dropdown-selector'
}